/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor packages below
import React, { useState } from 'react';
import { Row, Col, Button, Form, FormControl, OverlayTrigger } from 'react-bootstrap';

// import components below
import Table from 'components/ReactTable';
import ConfirmModal from './components/ConfirmModal';

// import assets below
import './index.scss';
import { ReactComponent as EyeSVG } from 'assets/svg/eye.svg';
import { ReactComponent as XmarkSVG } from 'assets/svg/circle-xmark-red.svg';
import { ReactComponent as ThreeDotsSVG } from 'assets/svg/three-dots-svgrepo-com.svg';

// main component
const samplePhoto = 'https://picsum.photos/id/237/200/300';

const state = [
  {
    avatar: samplePhoto,
    id: 1,
    name: 'Juan dela Cruz',
    date: '01-28-2023',
    log_in: '8:53 AM',
    log_out: '6:03 PM',
    status: 'Complete',
    task: '- Memo Distribution (March - April Holidays)',
  },
  {
    avatar: samplePhoto,
    id: 2,
    name: 'Juan dela Cruz',
    date: '01-29-2023',
    log_in: '8:57 AM',
    log_out: '6:07 PM',
    status: 'Complete',
    task: '- Memo Distribution (March - April Holidays)',
  },
  {
    avatar: samplePhoto,
    id: 3,
    name: 'Juan dela Cruz',
    date: '02-02-2023',
    log_in: '8:59 AM',
    log_out: '6:05 PM',
    status: 'Complete',
    task: '- Memo Distribution (March - April Holidays)',
  },
  {
    avatar: samplePhoto,
    id: 4,
    name: 'Juan dela Cruz',
    date: '02-04-2023',
    log_in: '8:49 AM',
    log_out: '6:03 PM',
    status: 'Complete',
    task: '- Memo Distribution (March - April Holidays)',
  },
];

const index = ({ setShowScreen, setRequestData }) => {
  const [openModal, setOpenModal] = useState();
  const [modalType, setModalType] = useState();

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Avatar', accessor: 'avatar' }, // accessor is the "key" in the data
      { Header: 'ID', accessor: 'id' }, // accessor is the "key" in the data
      { Header: 'Name', accessor: 'name' },
      { Header: 'Date', accessor: 'date' },
      { Header: 'Log-in', accessor: 'log_in' },
      { Header: 'Log-out', accessor: 'log_out' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      state?.map((dd) => ({
        name: dd?.name,
        id: dd?.id,
        log_out: dd?.log_out,
        date: dd?.date,
        log_in: dd?.log_in,
        status: dd?.status,
        task: dd?.task,
        avatar: <img src={dd?.avatar} className='avatar' />,
        data: dd,
      })),
    [state],
  );

  const handleDelete = () => {
    setModalType('delete');
    setOpenModal(true);
  };

  return (
    <div className='attendance-table'>
      <div className='main-table'>
        <Table
          data={tableData}
          columns={tableColumns}
          pagination={['BOTTOM']}
          customAction={(id, data) => {
            return (
              <div className='attendance-actions'>
                <EyeSVG
                  onClick={() => {
                    setShowScreen(2);
                    setRequestData(data);
                  }}
                  style={{ width: '1.5em', cursor: 'pointer' }}
                />
                <XmarkSVG
                  onClick={handleDelete}
                  className='delete'
                  style={{ width: '1.5em', cursor: 'pointer' }}
                />
              </div>
            );
          }}
        />
      </div>
      <ConfirmModal modalType={modalType} openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
};

export default index;
